import React from 'react';

export const DeviceInfoContext = React.createContext({});
export const SessionInfoContext = React.createContext({});
export const ClientChroniclesContext = React.createContext({});
export const AbTestingContext = React.createContext({});
